import { render, staticRenderFns } from "./ReviewsAverageRatings.vue?vue&type=template&id=10184c7e&scoped=true&"
import script from "./ReviewsAverageRatings.vue?vue&type=script&lang=js&"
export * from "./ReviewsAverageRatings.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAverageRatings.vue?vue&type=style&index=0&id=10184c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10184c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10184c7e')) {
      api.createRecord('10184c7e', component.options)
    } else {
      api.reload('10184c7e', component.options)
    }
    module.hot.accept("./ReviewsAverageRatings.vue?vue&type=template&id=10184c7e&scoped=true&", function () {
      api.rerender('10184c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/ReviewsAverageRatings.vue"
export default component.exports